import { createContext, useContext } from 'react'

import Immutable from 'immutable'

type Recipe = Immutable.Map<string, unknown>

/**
 *
 * A context to hold a single `Recipe` object
 *
 * To be used in e.g. RecipeTile and RecipeDetails
 *
 */
const RecipeContext = createContext<Recipe>(null as unknown as Recipe)
RecipeContext.displayName = 'RecipeContext'

export const RecipeContextProvider = RecipeContext.Provider
export const useRecipe = (): Recipe => useContext(RecipeContext)
export const useRecipeField = <TField = unknown>(
  fieldSelector: string | string[],
  notSetValue?: unknown,
): TField => {
  const recipe = useRecipe()

  if (!recipe) {
    return notSetValue as TField
  }

  if (Array.isArray(fieldSelector)) {
    return recipe.getIn(fieldSelector, notSetValue)
  }

  return recipe.get(fieldSelector, notSetValue) as TField
}

export const useRecipeId = (): string | null => useRecipeField<string | null>('id', null)
